<template>
  <div>
    <PageHeader
      :title="'การยืนยันตัวตนสมาชิกของ ' + memberInfo.firstName"
    ></PageHeader>
    <b-container class="mt-5">
      <div class="member-info-container">
        <div class="member-info-section">
          <h5>
            {{ fullName(memberInfo.firstName, memberInfo.lastName) }}
            <b-badge :variant="getStatusVariant(memberInfo.adminApproveStatus)">
              {{ getTextStatus(memberInfo.adminApproveStatus) }}
            </b-badge>
          </h5>

          <b-row>
            <b-col class="items-gap" cols="6">
              <b-row>
                <b-col cols="4">
                  <p>รหัสนักเรียน:</p>
                </b-col>
                <b-col cols="6">
                  <p>{{ memberInfo.studentId ?? "-" }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <p>E-mail:</p>
                </b-col>
                <b-col cols="6">
                  <p>{{ memberInfo.email }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <p>วันที่ขอยืนยันตัวตน:</p>
                </b-col>
                <b-col cols="6">
                  <p>{{ memberInfo.requestApproveAt | thaiDateFilter }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="items-gap" cols="6">
              <b-row>
                <b-col cols="3">
                  <p>ชื่อผู้เรียน:</p>
                </b-col>
                <b-col cols="6">
                  <p>
                    {{ fullName(memberInfo.firstName, memberInfo.lastName) }}
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <p>เบอร์ติดต่อ:</p>
                </b-col>
                <b-col cols="6">
                  <p>{{ memberInfo.phoneNumber ?? "-" }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <p>วันที่ดำเนินการ:</p>
                </b-col>
                <b-col cols="6">
                  <p>{{ memberInfo.adminApproveAt | thaiDateFilter }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="identification-image-section">
            <b-col class="image-section" cols="5">
              <b-img
                v-if="memberInfo.idCardPath"
                :src="`${baseUrl}/${memberInfo.idCardPath}?token=${token}`"
                class="card-img"
                alt
              ></b-img>
              <b-img
                v-else
                v-bind="mainProps"
                rounded
                alt="Rounded image"
              ></b-img>
              <p>รูปบัตรประจำตัวประชาชน</p>
            </b-col>

            <b-col class="image-section" cols="5">
              <b-img
                v-if="memberInfo.faceWithIdCardPhotoPath"
                :src="
                  `${baseUrl}/${memberInfo.faceWithIdCardPhotoPath}?token=${token}`
                "
                class="card-img"
                alt
              ></b-img>
              <b-img
                v-else
                v-bind="mainProps"
                rounded
                alt="Rounded image"
              ></b-img>
              <p>รูปใบหน้า</p>
            </b-col>
          </b-row>
        </div>

        <div class="admin-approve-section">
          <b-row>
            <b-col class="items-gap" cols="6">
              <h6>ข้อมูลส่วนตัว</h6>
              <div class="card card-csq no-shadow">
                <div class="card-body">
                  <b-row>
                    <b-col class="info-section" cols="6">
                      <div>
                        <label for="date-of-birth">
                          วันเกิด (วว/ดด/ค.ศ 4 หลัก)
                        </label>
                        <div class="date-range-field">
                          <b-input-group>
                            <b-form-input
                              size="sm"
                              type="text"
                              name="dateOfBirth"
                              :class="{ 'bg-white': isShowBtnAction }"
                              :value="formattedDateOfBirth"
                              placeholder="เลือกวันเกิด"
                              disabled
                            />
                            <b-input-group-prepend>
                              <b-button
                                size="sm"
                                variant="primary"
                                :disabled="!isShowBtnAction"
                                @click="showCalendar('date-of-birth')"
                              >
                                <b-icon icon="calendar"></b-icon>
                              </b-button>
                            </b-input-group-prepend>
                          </b-input-group>
                          <DatePicker
                            id="date-of-birth"
                            v-model="dateOfBirth"
                            :max-date="new Date()"
                            locale="th"
                            @input="editDateOfBirth"
                            style="
                              display: none;
                              float: right;
                              position: relative;
                              will-change: transform;
                              left: 0px;
                              "
                          />
                        </div>
                      </div>
                      <div>
                        <label for="id-card">เลขบัตรประจำตัวประชาชน</label>
                        <b-form-input
                          v-model="idCardNumber"
                          name="idCard"
                          type="text"
                          class="form-control border-1"
                          autofocus
                          placeholder="กรอกเลขบัตรประจำตัวประชาชน"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          maxlength="13"
                          :state="idCardState"
                          :disabled="!isShowBtnAction"
                          aria-describedby="input-id-card"
                          @change="editIdCardNumber"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-id-card">
                          กรุณากรอกเลขประจำตัวประชาชน 13 หลัก
                        </b-form-invalid-feedback>
                      </div>
                      <div>
                        <label for="gender">เพศ</label>
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio-group
                            v-model="genderSelected"
                            :options="genderOptions"
                            :aria-describedby="ariaDescribedby"
                            :disabled="!isShowBtnAction"
                            name="gender"
                            stacked
                            @change="editGender"
                          ></b-form-radio-group>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col
              v-if="memberInfo.adminApproveStatus === 'REJECTED'"
              class="items-gap"
              cols="6"
            >
              <h6>เหตุผลการปฏิเสธ</h6>
              <div class="card card-csq no-shadow">
                <div class="card-body">
                  <p>{{ memberInfo.adminApproveRemark ?? "-" }}</p>
                </div>
              </div>
            </b-col>
          </b-row>

          <div class="action-section">
            <router-link
              :to="{
                name: 'member.identity-verification',
              }"
            >
              <p><b-icon icon="arrow-left"></b-icon> ย้อนกลับ</p>
            </router-link>
            <div v-if="isShowBtnAction" class="button-group">
              <b-button variant="danger" @click="isShowRejectModal = true">
                ปฏิเสธ
              </b-button>
              <b-button
                variant="success"
                @click="
                  identityVerificationConfirmed('APPROVED');
                  isShowApproveModal = true;
                "
                :disabled="!idCardNumber"
              >
                บันทึกและยืนยัน
              </b-button>

              <b-modal
                v-model="isShowApproveModal"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
              >
                <div class="modal-approve-section">
                  <b-icon
                    icon="check-circle"
                    variant="success"
                    style="width: 80px; height: 80px;"
                  ></b-icon>
                  <h4>การยืนยันตัวตนสมาชิกสำเร็จ</h4>
                  <b-button @click="approveSuccess()" variant="primary">
                    เสร็จสิ้น
                  </b-button>
                </div>
              </b-modal>

              <b-modal
                v-model="isShowRejectModal"
                centered
                hide-footer
                title="เหตุผลการปฏิเสธ"
              >
                <div class="modal-reject-section">
                  <div>
                    <label for="remark">รายละเอียดการปฏิเสธ</label>
                    <b-form-textarea
                      id="textarea"
                      v-model="remark"
                      placeholder="Enter something..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <div class="button-group">
                    <b-button
                      variant="outline-secondary"
                      @click="isShowRejectModal = false"
                    >
                      ยกเลิก
                    </b-button>
                    <b-button variant="danger" @click="rejectMember()">
                      ปฏิเสธ
                    </b-button>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import api from "../../../services/api";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import { mapActions } from "vuex";

export default {
  mixins: [dateMixin],
  components: {
    PageHeader,
    DatePicker,
  },
  computed: {
    formattedDateOfBirth() {
      if (!this.dateOfBirth) {
        return "";
      }
      return this.thaiDateFilter(moment(this.dateOfBirth).format("YYYY-MM-DD"));
    },
    idCardState() {
      if (this.idCardNumber) {
        return this.idCardNumber.length == 13 ? null : false;
      }
      return false;
    },
  },
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      memberId: this.$route.params.memberId,
      token: localStorage.getItem("token"),
      baseUrl:
        process.env.VUE_APP_FILE_REC_ACCESS_SERVICE_URL ||
        "https://cs-file-access-service-20220905.coursesquare.com",
      memberInfo: {},
      dateOfBirth: "",
      idCardNumber: "",
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 300,
        height: 300,
        class: "m1",
      },
      genderSelected: "",
      genderOptions: [
        { text: "ชาย", value: "m" },
        { text: "หญิง", value: "f" },
        { text: "ไม่มีข้อมูล", value: "" },
      ],
      isShowBtnAction: false,
      isShowApproveModal: false,
      isShowRejectModal: false,
      remark: null,
    };
  },
  mounted() {
    this.getMember();
  },
  methods: {
    ...mapActions("MemberManagement", ["confirmMemberByAdmin"]),
    async getMember() {
      await api
        .get(`/v1/members/${this.memberId}`)
        .then(({ data }) => {
          this.memberInfo = data.data;
          this.dateOfBirth = this.memberInfo.dateOfBirth;
          this.idCardNumber = this.memberInfo.idCard;
          this.genderSelected = this.memberInfo.gender ?? "";
          this.isShowBtnAction =
            this.memberInfo.adminApproveStatus == "SUBMITTED";
        })
        .catch(() => {});
    },
    editDateOfBirth(dateOfBirth) {
      let dob = moment(dateOfBirth).format("YYYY-MM-DD");
      if (dateOfBirth && this.memberInfo.dateOfBirth != dob) {
        this.patch({
          name: "dateOfBirth",
          value: dob,
        });
      }
    },
    editIdCardNumber(idCard) {
      if (idCard.length === 13) {
        this.patch({
          name: "idCard",
          value: idCard,
        });
      }
    },
    editGender(gender) {
      this.patch({
        name: "gender",
        value: gender,
      });
    },
    async patch(data) {
      let payload = { [data.name]: data.value };

      await api
        .patch(`/v1/members/${this.memberId}?company=${this.comId}`, payload)
        .then(() => {
          this.$bvToast.toast("บันทึกข้อมูลเรียบร้อยแล้ว", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });
        })
        .catch(({ response }) => {
          this.$bvToast.toast(response.data.message, {
            variant: "danger",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });
          return false;
        });
    },
    async identityVerificationConfirmed(status) {
      let params = {
        mId: this.memberId,
        status: status,
        remark: this.remark,
      };
      await this.confirmMemberByAdmin(params);
    },
    approveSuccess() {
      this.isShowApproveModal = false;
      this.$router.push({
        name: "member.identity-verification",
      });
    },
    async rejectMember() {
      await this.identityVerificationConfirmed("REJECTED");
      this.$router.push({
        name: "member.identity-verification",
      });
    },
    fullName(firstName, lastName) {
      if (!firstName || !lastName) {
        return "-";
      }
      return firstName + " " + lastName;
    },
    showCalendar(calendarId) {
      let calendar = document.getElementById(calendarId);
      if (calendar.style.display == "inline-block") {
        calendar.style.display = "none";
      } else {
        calendar.style.display = "inline-block";
      }
    },
    getStatusVariant(status) {
      const variants = {
        SUBMITTED: "secondary",
        APPROVED: "success",
        REJECTED: "danger",
      };
      return variants[status] || "secondary";
    },
    getTextStatus(status) {
      const text = {
        SUBMITTED: "ยังไม่ยืนยัน",
        APPROVED: "ยืนยัน",
        REJECTED: "ปฏิเสธ",
      };
      return text[status] || "-";
    },
  },
};
</script>

<style scoped>
.member-info-container {
  display: flex;
  flex-direction: column;
  gap: 80px;

  .badge {
    font-size: 12px;
    padding: 5px 7px;
  }

  .member-info-section {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .admin-approve-section {
    display: flex;
    flex-direction: column;
    gap: 50px;

    h6 {
      font-size: 18px;
      font-weight: 500;
    }

    .info-section {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
  }

  a:hover {
    text-decoration: none;
  }

  .card-csq {
    min-height: 410px;
  }

  .date-range-field {
    .bg-white {
      background-color: #fff;
    }
  }

  .items-gap {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .identification-image-section {
    justify-content: center;

    .image-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  }

  .action-section {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h6 {
      color: #027bff;
      font-size: 16px;
    }

    .button-group {
      display: flex;
      gap: 10px;
    }
  }
}

.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 2;
}

.modal-approve-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.modal-reject-section {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
